import HttpClientXml from "../utils/HttpClientXml";

// >>>All Get Api<<<
// const getLoginData = async () => {
//     let endPoint = "login";
//     return HttpClientXml.get(endPoint);
// };


// >>>All Post Api<<<
const register = async (data) => {
    let endPoint = "register";
    return HttpClientXml.post(endPoint, data);
};
const getLogin = async (data) => {
    let endPoint = "login";
    return HttpClientXml.post(endPoint, data);
};

export default {
    // >>>All Get<<<
    getLogin, register,

    // >>>All Post<<<

}